import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getMedicationDetails } from '@api/medications';
import { IMedicationDetails } from '@interfaces/medications';

export const handleGetMedicationDetails = createAsyncThunk<
  AxiosResponse<IMedicationDetails>,
  number
>('getMedicationDetails', getMedicationDetails);
